module.exports = "/_next/static/images/William_Carithers-97d2819860744c5b1119099bb3065d8a.webp";